export interface IPaymentDetail {
  invoiceNumber: string,
}

export interface IPaymentPayload {
  paymentDetails: IPaymentDetail[],
}

/**
   * Checks if the object is a valid IPaymentDetail
   * @param data unknown object
   * @returns boolean
   */
export const isIPaymentDetail = (data: unknown): data is IPaymentDetail => {
  const paymentDetail = data as IPaymentDetail;
  return (
    paymentDetail.invoiceNumber !== null
      && paymentDetail.invoiceNumber !== undefined
      && paymentDetail.invoiceNumber.length > 0
  );
};

/**
   * Checks if the array is a valid IPaymentDetail array
   * @param data unknown array
   * @returns boolean
   */
export const isIPaymentDetailArray = (data: unknown[]): data is IPaymentDetail[] => (
  data.every(isIPaymentDetail)
);

export const isIPaymentPayload = (data: unknown): data is IPaymentPayload => {
  const payload = data as IPaymentPayload;
  return (
    isIPaymentDetailArray(payload.paymentDetails)
  );
};
